import { Translate } from "components/common/Translate/Translate";
import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { BadgeIcon } from "components/common/Icons/BadgeIcon";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";

export const EnlargerContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-best-title" />}
                description={<Translate keyName="content-best-sub-title" />}
                icon={<BadgeIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-size-title" />}
                description={<Translate keyName="content-size-sub-title" />}
                icon={<PerfectQualityIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<HeartIcon />}
            />
        </ContentParent>
    );
};
